"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "SupportLink", {
  enumerable: true,
  get: function get() {
    return _SupportLink["default"];
  }
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _classnames = _interopRequireDefault(require("classnames"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _SupportLink = _interopRequireDefault(require("./SupportLink"));

var _excluded = ["variant", "as", "className", "title", "body", "supportingText", "children"];

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

// eslint-disable-next-line max-lines-per-function
var ErrorPages = /*#__PURE__*/_react["default"].forwardRef(function (props, ref) {
  var variant = props.variant,
      as = props.as,
      className = props.className,
      title = props.title,
      body = props.body,
      supportingText = props.supportingText,
      children = props.children,
      otherProps = _objectWithoutProperties(props, _excluded);

  var Component = as;
  var classes = (0, _classnames["default"])(className, _defineProperty({}, "pds-".concat(variant, "Error-background"), variant));

  if (variant === "server") {
    return /*#__PURE__*/_react["default"].createElement(Component, _extends({
      className: classes,
      ref: ref
    }, otherProps), /*#__PURE__*/_react["default"].createElement("section", {
      className: "pds-imgCalebThePlumber pds-util-padding-top-20 pds-util-padding-bottom-10"
    }, /*#__PURE__*/_react["default"].createElement("div", {
      className: "pds-typography-center"
    }, /*#__PURE__*/_react["default"].createElement("div", null, /*#__PURE__*/_react["default"].createElement("h1", {
      className: "pds-typography-h2 pds-util-margin-top-10 pds-util-margin-bottom-0"
    }, title)), /*#__PURE__*/_react["default"].createElement("div", {
      className: "pds-util-padding-horz-10"
    }, /*#__PURE__*/_react["default"].createElement("p", {
      className: "pds-util-margin-vert-0"
    }, body), /*#__PURE__*/_react["default"].createElement("p", {
      className: "pds-util-margin-vert-0"
    }, children)))));
  }

  if (variant === "notFound") {
    return /*#__PURE__*/_react["default"].createElement(Component, _extends({
      className: classes,
      ref: ref
    }, otherProps), /*#__PURE__*/_react["default"].createElement("section", {
      className: "pds-imgCarrollTheLibrarian"
    }, /*#__PURE__*/_react["default"].createElement("div", {
      className: "pds-typography-center"
    }, /*#__PURE__*/_react["default"].createElement("div", {
      className: "pds-util-padding-horz-10"
    }, /*#__PURE__*/_react["default"].createElement("h1", {
      className: "pds-typography-h2 pds-util-margin-top-20 pds-util-margin-bottom-10"
    }, title), /*#__PURE__*/_react["default"].createElement("p", {
      className: "pds-util-margin-top-0 pds-util-margin-bottom-10"
    }, body)), /*#__PURE__*/_react["default"].createElement("p", {
      className: "pds-util-margin-top-0 pds-util-margin-bottom-10 pds-util-padding-horz-10"
    }, children))));
  }

  if (variant === "maintenance") {
    return /*#__PURE__*/_react["default"].createElement(Component, _extends({
      className: classes,
      ref: ref
    }, otherProps), /*#__PURE__*/_react["default"].createElement("div", {
      className: "pds-typography-center"
    }, /*#__PURE__*/_react["default"].createElement("div", null, /*#__PURE__*/_react["default"].createElement("h1", {
      className: "pds-util-margin-top-20 pds-util-margin-bottom-10"
    }, title)), /*#__PURE__*/_react["default"].createElement("div", {
      className: "pds-util-padding-horz-10"
    }, /*#__PURE__*/_react["default"].createElement("strong", null, /*#__PURE__*/_react["default"].createElement("p", {
      className: "pds-util-margin-top-0 pds-util-margin-10"
    }, body)), /*#__PURE__*/_react["default"].createElement("p", {
      className: "pds-util-margin-top-0 pds-util-margin-bottom-10"
    }, supportingText))), /*#__PURE__*/_react["default"].createElement("section", {
      className: "pds-error-page pds-imgMarkTheMechanic pds-util-padding-top-20 pds-util-padding-bottom-10"
    }));
  }

  if (variant === "unauthenticated") {
    return /*#__PURE__*/_react["default"].createElement(Component, _extends({
      className: classes,
      ref: ref
    }, otherProps), /*#__PURE__*/_react["default"].createElement("section", {
      className: "pds-imgStanTheMan pds-util-padding-top-20 pds-util-padding-bottom-10"
    }, /*#__PURE__*/_react["default"].createElement("div", {
      className: "pds-typography-center"
    }, /*#__PURE__*/_react["default"].createElement("div", null, /*#__PURE__*/_react["default"].createElement("h1", {
      className: "pds-typography-h2 pds-util-margin-top-10 pds-util-margin-bottom-0"
    }, title)), /*#__PURE__*/_react["default"].createElement("div", {
      className: "pds-util-padding-horz-10"
    }, /*#__PURE__*/_react["default"].createElement("p", {
      className: "pds-util-margin-vert-0"
    }, body), /*#__PURE__*/_react["default"].createElement("p", {
      className: "pds-util-margin-vert-0"
    }, children)))));
  }

  return "";
});

ErrorPages.displayName = "Error Pages";
ErrorPages.propTypes = {
  /** Title of error page */
  title: _propTypes["default"].node,

  /** Body text for the page */
  body: _propTypes["default"].node,

  /** Variation of error page */
  variant: _propTypes["default"].oneOf(["server", "notFound", "maintenance", "unauthenticated"]).isRequired,

  /** Supporting text for maintenance pages */
  supportingText: _propTypes["default"].node,

  /** Child usually support link would be inserted */
  children: _propTypes["default"].elementType,

  /** Additional classes if needed */
  className: _propTypes["default"].string,

  /** To change the root html element */
  as: _propTypes["default"].elementType
};
ErrorPages.defaultProps = {
  as: "div"
};
var _default = ErrorPages;
exports["default"] = _default;